import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {CustomerService} from "../../customer/customer-service";
import {ProjectService} from "../../project/project.service";
import {CustomerModel} from "../../customer/customer.model";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {toggleLoading} from "../../misc/loading.decorator";
import {CreateCustomerFleetDialogComponent} from "./create-customer-fleet-dialog.component";
import {RejectCustomerFleetDialogComponent} from "./reject-customer-fleet-dialog.component";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 5;

@Component({
  templateUrl: "./select-customer-fleet.template.pug",
  providers: [
    ProjectService,
    CustomerService,
  ],
})

export class SelectCustomerFleetComponent extends WorkflowStep {
  error: Error;
  project: any = {};
  customers: CustomerModel[] = [];
  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  totalCount: number = 0;
  searchText: string = "";
  loading: boolean = true;
  selectedCustomer: CustomerModel = null;
  expandId: string = "";
  editId: string = "";
  alertMessage: string;

  checkStepIsComplete() {
    if (this.project.customerFleet && this.project.customerFleet.trim().length > 0) {
      this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
    }
  }

  @handleErrors()
  async loadCustomerFleets() {
    let resp = {rows: [], count: 0};

    resp = await this.customerService.list(
      +(this.currentPage) - 1,
      +(this.pageSize),
      this.searchText,
    );

    const rows = resp.rows;
    const count = resp.count;
    this.customers = rows;
    this.maxPages = Math.ceil(count / (+this.pageSize));
    this.totalCount = count;
    this.updateCustomerList();
  }

  @toggleLoading()
  @handleErrors()
  async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.project = await this.projectService.getProjectById(workflowTargetInfo.targetId).toPromise();

    // TODO: if exists project.customerFleet, selectedCustomer need to be populated
    await this.loadCustomerFleets();
    this.checkStepIsComplete();
  }

  @handleErrors()
  async setCustomerFleet(customer): Promise<boolean> {
    // TODO: implement back-ed api for fleet
    await this.projectService.saveCustomer(this.project.id, customer.id, customer.name).toPromise();

    this.project.k2Customer = customer.id; // TODO: remove k2 after back-end is implemented
    this.project.k2CustomerName = customer.name; // TODO: remove k2 after back-end is implemented

    this.expandId = "";
    this.project.customerFleet = customer.id;
    this.selectedCustomer = customer;
    await this.loadCustomerFleets();
    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
    return true;
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }

    this.loadCustomerFleets();
  }

  @handleErrors()
  async rejectCustomerFleet(): Promise<boolean> {
    this.alertMessage = "";
    const result = await RejectCustomerFleetDialogComponent.RejectCustomerFleet(this.dialogService, {
      projectId: this.project.id,
    }).toPromise();

    if (result.success) {
      this.expandId = "";
      this.project.customerFleet = "";
      this.selectedCustomer = null;
      await this.loadCustomerFleets();
      this.alertMessage = "TM has been notified of rejection.";
    }
    return true;
  }

  @handleErrors()
  async createCustomerFleet(): Promise<boolean> {
    this.alertMessage = "";
    const result = await CreateCustomerFleetDialogComponent.showDialogModal(this.dialogService, {
      projectId: this.project.id,
    }).toPromise();

    if (result.success) {
      await this.loadCustomerFleets();
    }
    return true;
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public projectService: ProjectService,
    public customerService: CustomerService,
    public dialogService: DialogService,
  ) {
    super();
  }

  toggleExpand(id) {
    this.editId = "";
    this.expandId = (this.expandId === id) ? "" : id;
    if (this.expandId) {
      // TODO: API may be needed to retrieve the customer fleet detail data
    }
  }

  saveCustomerFleet(customer) {
    // TODO: implement new api for customer fleet headers and remove the console.log
    console.log("customer", customer);

    this.editId = "";
  }

  updateCustomerList() {
    // TODO: re-facture this code after backend fleet api is implemented
    if (this.selectedCustomer && this.customers.length > 0 && this.customers[0].id !== this.selectedCustomer.id) {
      this.customers = [this.selectedCustomer, ...this.customers];
    }
    this.alertMessage = "";
  }
}
